<div class="list-header">
    <div class="toggle-spacer"></div>
    <div class="list-header-content">
        <ng-content select="[list-header]"></ng-content>
    </div>
</div>
<div>
    <ng-content #list>

    </ng-content>
</div>
